/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Contactcode1Inputs */

const en_entity_contactcode1 = /** @type {(inputs: Entity_Contactcode1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Code`)
};

const de_entity_contactcode1 = /** @type {(inputs: Entity_Contactcode1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt Code`)
};

/**
* | output |
* | --- |
* | "Contact Code" |
*
* @param {Entity_Contactcode1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_contactcode1 = /** @type {((inputs?: Entity_Contactcode1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Contactcode1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_contactcode1(inputs)
	return de_entity_contactcode1(inputs)
});
export { entity_contactcode1 as "entity_contactCode" }